{#if configRequired}
  <p>
    The newsletter form requires that you configure Campaign Monitor or MailChimp in the site configuration
    and set a list key in the plugin settings.
  </p>
{:else}
  {#if showSuccess}
    <div class="newsletter-container newsletter-container--success">
      <p>{fields.success}</p>
    </div>
  {:else if showError}
    <div class="newsletter-container newsletter-container--failure">
      <p>{fields.failure}</p>
    </div>
  {:else}
    <div class="newsletter-container">
      <noscript><p>The Newsletter Form requires JavaScript to function correctly.</p></noscript>

      {#if fields?.description}
        <p>{fields.description}</p>
      {/if}

      {#if showDuplicate}
        <div class="newsletter-container newsletter-container--duplicate">
          <p>This email address has already been added.</p>
        </div>
      {/if}

      <div class="newsletter-input">
        {#if fields.inputLabel}
          <label for="newsletter-plugin__input">{fields.inputLabel}</label>
        {/if}

        <input id="newsletter-plugin__input" type="email" bind:value={email}>
      </div>

      {#if fields.nameLabel && campaignMonitorListKey}
        <div class="newsletter-input">
          <label for="newsletter-plugin__input">{fields.nameLabel}</label>
          <input id="newsletter-plugin__input" type="text" bind:value={name}>
        </div>
      {/if}

      <button on:click={signup}>{fields.submitCaption}</button>
    </div>
  {/if}
{/if}

<script context="module">export const svelteCompilerVersion = {"major":4,"minor":2,"patch":18};
  export const classNames = ['plugin__newsletter']
</script>

<script>
  import { onMount, getContext } from 'svelte'

  export let fields = {}

  const platform = getContext('platform')

  let mailchimpListKey = ''
  let campaignMonitorListKey = ''
  let configRequired = ''
  let showSuccess = false
  let showError = false
  let showDuplicate
  let email = ''
  let name = ''

  async function signup () {
    platform.api.core.loading.show()

    if (campaignMonitorListKey) {
      try {
        await platform.api.cms.campaignMonitor.addSubscriberToList(campaignMonitorListKey, {
          email,
          name,
        })

        showSuccess = true
      } catch (err) {
        console.error(err)

        showError = true
      }
    }

    if (mailchimpListKey) {
      try {
        const existingEmail = await platform.api.cms.mailchimp.checkExistingUser({
          listKey: mailchimpListKey,
          emailAddress: email,
        })

        if (existingEmail) {
          showDuplicate = true
        } else {
          showDuplicate = false
          await platform.api.cms.mailchimp.addSubscriberToList({
            listKey: mailchimpListKey,
            emailAddress: email,
          })
          showSuccess = true
        }
      } catch (err) {
        console.error(err)

        showError = true
      }
    }

    platform.api.core.loading.hide()
  }

  onMount(async () => {
    try {
      const config = await platform.api.cms.config.findAllAsObject()

      mailchimpListKey = config.mailchimpListKey.value
      campaignMonitorListKey = config.campaignMonitorListKey.value
    } catch (err) {
      console.error(err)
    }

    if (fields.mailchimpListKey) {
      mailchimpListKey = fields.mailchimpListKey
    }

    if (fields.listKey) {
      campaignMonitorListKey = fields.listKey
    }

    if (!campaignMonitorListKey && !mailchimpListKey) {
      configRequired = true
    }
  })

</script>
